export const sliderItems = [
{
    id:1,
    img: "https://www.kindpng.com/picc/m/127-1277774_cara-delevingne-transparent-background-transparent-background-fashion-model.png",
    title:"SUMMER SALE",
    desc: "ELIT FINIBUS FINIBUS LACINIA, FELIS NEQUE ULTRICES NIBH, ELEIFEND SCELERISQUE AUGUE URNA VULPUTATE LEO.",
    bg:"f5fafd"
},
{
    id:2,
    img: "https://www.pngkey.com/png/detail/23-232092_model-png-image-with-transparent-background-model.png",
    title:"AUTUMN COLLECTION",
    desc:"ELIT FINIBUS FINIBUS LACINIA, FELIS NEQUE ULTRICES NIBH, ELEIFEND SCELERISQUE AUGUE URNA VULPUTATE LEO.",
    bg:"fcf1ed"
},
{
    id:3,
    img: "https://www.pngitem.com/pimgs/m/275-2757121_red-dress-fashion-transparent-background-model-png-png.png",
    title:"LOUNGEWEAR LOVE",
    desc:"ELIT FINIBUS FINIBUS LACINIA, FELIS NEQUE ULTRICES NIBH, ELEIFEND SCELERISQUE AUGUE URNA VULPUTATE LEO.",
    bg:"fbf0f4"
},
]

export const categories = [
    {
        id:1,
        img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        title:"SHIRT STYLE!",
        cat:"women"
    },
    {
        id:2,
        img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        title:"LOUNGEWEAR LOVE",
        cat:"coat"

    },
    {
        id:3,
        img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        title:"LIGHT JACKETS",
        cat:"jeans"

    },
]

export const popularProducts = [
    {
      id:1,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    {
      id:2,
      img:"http://render.fineartamerica.com/images/rendered/default/t-shirt/23/9/images/artworkimages/medium/1/ronin-nicklas-gustafsson-transparent.png?&targetx=26&targety=-2&imagewidth=370&imageheight=576&modelwidth=430&modelheight=575",
    },
    {
      id:3,
      img:"https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
    },
    {
      id:4,
      img:"https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
    },
    {
      id:5,
      img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
    },
    {
      id:6,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
    },
    {
      id:7,
      img:"https://render.fineartamerica.com/images/rendered/default/t-shirt/29/2/images/artworkimages/medium/1/cancan-girl-in-white-transparent-background-barbara-st-jean-transparent.png?targetx=0&targety=0&imagewidth=300&imageheight=300&modelwidth=300&modelheight=405",
    },
    {
      id:8,
      img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
  ]